import { datadogRum } from '@datadog/browser-rum'
import { FeatureFlagProvider, LDProvider, MockProvider } from '@touchbistro/react-feature-flags'
import browserConfig from '~/src/shared/config/browser'

export const LD_FLAG_RESET_RMM = 'vaf.reset-rmm'
export const LD_FLAG_CLOUD_FLOORPLAN_V1 = 'cloud.floorplan-v1'
export const LD_FLAG_SHOW_EMPTY_FLOORPLAN = 'ark.show-empty-floorplan'
export const LD_FLAG_CLOUD_FLOORPLAN_CASH_REGISTER_AUTO_NUMBERING =
  'cloud.floorplan-cash-register-auto-numbering'
export const LD_FLAG_CLOUD_FLOORPLAN_USER_FRIENDLY_ERROR = 'cloud.floorplan-user-friendly-error'
export const LD_FLAG_DOWNTIME_BANNER = 'cloud-downtime-banner'
/** @deprecated */
export const LD_FLAG_PROMOTIONS = 'vaf.promotions'
export const LD_FLAG_DEVICE_LINKING = 'vaf.device-link-menu'
export const LD_FLAG_POST_ACTIVATION_LANDING_PAGE = 'ark.post-activation-landing-page'

// Invenue Staff
export const LD_SLF_CUSTOM_ROLES = 'slf.custom-roles'
export const LD_FLAG_OO_DEV = 'oo.dev'

export const LD_FLAG_ALL_USER_ACCESS_IMPORT_EXPORT = 'vcs.enable-all-user-access-import-export'
export const LD_FLAG_STATIC_CLOUD_FLOORPLAN_ENHANCEMENTS =
  'ark.static-cloud-flooplan-enhancements-june2022'
export const LD_FLAG_CLOUD_FLOORPLAN_TOUCH_CONTROL = 'ark.res-floorplan-touch-control'
export const LD_FLAG_IOS_SHIFT_MANAGEMENT = 'ark.ios-shift-management'
export const LD_FLAG_STAFF_OVERTIME_RULES_2026 = 'ark.staff-overtime-rules-2026'

// MARKETPLACE - IMPORTED FROM VAF
export const LD_FLAG_AUTO_ONBOARDING_LOYALTY = 'vcs.lylty-auto-onboarding'

export const LD_FLAG_MARGINEDGE_OLD_USERS = 'ark.margine-edge-old-flow-users'
export const LD_FLAG_TB_LABOR = 'ark.peachworks-shift-enforcement'
export const LD_FLAG_PAPIS_AUTO_ENABLED_VENUE_INTEGRATION = 'papis-auto-enable-venue-integration'

// RMM3 - Menu Management
export const LD_FLAG_HIDE_PLU_RMM3 = 'ark.hide-plu-rmm3'
export const LD_FLAG_POS_DEMO = 'ark.menu-preview-pos'
export const LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2 = 'slf.upgrade-user-flow-2023-q2'
export const LD_FLAG_ENABLE_CASH_DISCOUNT = 'cloud.cash-discounts'
export const LD_FLAG_RMM3_STOCK_AVAILABILITY = 'ark.rmm3-stock-availability'
export const LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR = 'ark.unpublished-changes-indicator'

// This feature flag represents EXCLUSIVELY displaying the new version of the single and multi base selector
// without any of the other functionality that comes with enabling venue groups
export const LD_FLAG_NEW_SELECTORS = 'ark.new-selectors'

export const LD_POS_ADMIN_POLICY_ASSIGNMENT = 'ark.pos-admin-policy-assignment'

// _______________PAYMENTS______________
// Payment Settings
export const LD_FLAG_PAYMENT_SETTINGS = 'ark.payment-settings'
export const LD_FLAG_PAYMENT_SETTINGS_BETA_TERMINALS = 'pay-payment-settings-beta-terminals'

// Receipt Settings
export const LD_FLAG_RECEIPT_SETTINGS_IOS = 'ark.receipt-settings-ios'
export const LD_FLAG_RECEIPT_SETTINGS_PAX = 'ark.receipt-settings-pax'
// QSR Payments in Cloud
export const LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS = 'tb-android.cloud-payments-pc1p'
// _______________PAYMENTS______________

// New Cloud CRM
export const LD_FLAG_GUEST_CRM = 'cloud.guest-crm'

// Reports Payments
export const LD_FLAG_PURCHASES = 'pay.reports.purchases.enabled'
export const LD_FLAG_DEPOSITS = 'pay.reports.deposits.enabled'

// Bill Processor Entitlement
export const LD_FLAG_BILL_PROCESSOR_AGENT_FORM = 'ark.bill-processor-entitlement-form'

// Salesforce Experience Cloud Customer Portal
export const LD_FLAG_SALESFORCE_XP_CLOUD = 'salesforce.enable-experience-cloud-portal'

// Reporting v2 static reports
export const LD_FLAG_REPORTING_V2_INTERNAL_REVIEW = 'ark.reporting-v2-internal-review'
// Shared incubation gate for all in-progress Advanced Reporting features — add new AR
// features here rather than minting a per-feature flag. Long-lived; not an archive
// candidate. See src/domains/reports/v2/AGENTS.md § Feature Incubation.
export const LD_FLAG_REPORTING_V2_EXPERIMENT = 'ark.report-v2-experiment'
export const LD_FLAG_REPORTING_EXPAND_ONLY_NAV = 'vcs.reporting-expand-only-nav'
// Launch gate for the All Reports Library page (src/domains/reports/v2/components/AllReportsLibraryPage).
export const LD_FLAG_INSIGHTS_REPORT_LIBRARY = 'cloud.insights.report-library.202609'

// Advanced Discount
export const LD_FLAG_ADVANCED_DISCOUNT_V2 = 'cloud.advanced-discount-v2'

export const LD_FLAG_DEFERRED_GIFT_CARD_SALES = 'vcs.deferred-gift-card-sales'

export const LD_FLAG_ANDROID_DISCOUNT_BLOCK = 'ark.android-discount-block'
// TBOne Device Linking and Licences
export const LD_FLAG_TB_ONE_DEVICE_LINKING = 'ark.aio-tb-one-device-linking'
export const LD_FLAG_MONERIS_TB_ONE_DEVICE_LINKING = 'aio.moneris-tb-one-device-linking'

// referal page
export const LD_FLAG_REFER_AND_EARN = 'referral-page'

let provider: FeatureFlagProvider

if (browserConfig.ldClientId !== '') {
  provider = new LDProvider(browserConfig.ldClientId, {
    fetchGoals: false,
    streaming: false,
    inspectors: [
      {
        type: 'flag-used',
        name: 'dd-inspector',
        method: (key: string, detail: { value: unknown }) => {
          datadogRum.addFeatureFlagEvaluation(key.replaceAll('.', '_'), detail.value)
        },
      },
    ],
  })
} else {
  const reservationsBaseXRefIDs = [
    50000, 50001, 50002, 50003, 50004, 50005, 50006, 50007, 50008, 50009, 50010, 50011, 50012,
    50013, 50014, 50015, 50016, 50017,
  ]

  const reservationsFlags = reservationsBaseXRefIDs.reduce(
    (mockFlags, XRefID) => ({
      ...mockFlags,
      [`baseXRefID-${XRefID}`]: {
        flags: {
          [LD_FLAG_RESET_RMM]: true,
          [LD_FLAG_CLOUD_FLOORPLAN_V1]: true,
          [LD_FLAG_SHOW_EMPTY_FLOORPLAN]: true,
          [LD_FLAG_CLOUD_FLOORPLAN_CASH_REGISTER_AUTO_NUMBERING]: true,
          [LD_FLAG_CLOUD_FLOORPLAN_USER_FRIENDLY_ERROR]: true,
          [LD_FLAG_STATIC_CLOUD_FLOORPLAN_ENHANCEMENTS]: true,
          [LD_FLAG_CLOUD_FLOORPLAN_TOUCH_CONTROL]: true,
          [LD_FLAG_PROMOTIONS]: true,
          [LD_FLAG_DEVICE_LINKING]: true,
          [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
          [LD_FLAG_OO_DEV]: false,
          [LD_FLAG_POST_ACTIVATION_LANDING_PAGE]: true,
          [LD_FLAG_HIDE_PLU_RMM3]: true,
          [LD_FLAG_AUTO_ONBOARDING_LOYALTY]: true,
          [LD_FLAG_POS_DEMO]: true,
          [LD_FLAG_MARGINEDGE_OLD_USERS]: true,
          [LD_FLAG_NEW_SELECTORS]: true,
        },
      },
    }),
    {}
  )

  const reportsBaseXRefIDs = ['test_50348', 'test_50349', 'test_55227', 'test_58128', 'test_3290']
  const reportsFlags = reportsBaseXRefIDs.reduce(
    (mockFlags, XRefID) => ({
      ...mockFlags,
      [`baseXRefID-${XRefID}`]: {
        flags: {
          [LD_FLAG_REPORTING_V2_INTERNAL_REVIEW]: true,
          [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        },
      },
    }),
    {}
  )

  provider = new MockProvider({
    // tb-devmenu
    'baseXRefID-24477': {
      flags: {
        [LD_FLAG_REFER_AND_EARN]: true,
        [LD_FLAG_RESET_RMM]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_V1]: true,
        [LD_FLAG_SHOW_EMPTY_FLOORPLAN]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_CASH_REGISTER_AUTO_NUMBERING]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_USER_FRIENDLY_ERROR]: true,
        [LD_FLAG_STATIC_CLOUD_FLOORPLAN_ENHANCEMENTS]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_TOUCH_CONTROL]: true,
        [LD_FLAG_PROMOTIONS]: true,
        [LD_FLAG_DEVICE_LINKING]: true,
        [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
        [LD_FLAG_OO_DEV]: false,
        [LD_FLAG_POST_ACTIVATION_LANDING_PAGE]: true,
        [LD_FLAG_HIDE_PLU_RMM3]: true,
        [LD_FLAG_AUTO_ONBOARDING_LOYALTY]: true,
        [LD_FLAG_POS_DEMO]: true,
        [LD_FLAG_MARGINEDGE_OLD_USERS]: true,
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_POS_ADMIN_POLICY_ASSIGNMENT]: true,
        [LD_FLAG_TB_LABOR]: true,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_PAPIS_AUTO_ENABLED_VENUE_INTEGRATION]: true,
        [LD_FLAG_GUEST_CRM]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_PAX]: true,
        [LD_FLAG_BILL_PROCESSOR_AGENT_FORM]: true,
        [LD_FLAG_PURCHASES]: true,
        [LD_FLAG_DEPOSITS]: true,
        [LD_FLAG_ENABLE_CASH_DISCOUNT]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS]: true,
        [LD_FLAG_SALESFORCE_XP_CLOUD]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        [LD_FLAG_INSIGHTS_REPORT_LIBRARY]: true,
        // [LD_FLAG_REPORTING_V2_INTERNAL_REVIEW]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_STAFF_OVERTIME_RULES_2026]: true,
        [LD_FLAG_DEFERRED_GIFT_CARD_SALES]: true,
      },
    },
    // Root of baseXRefID-24477
    'baseXRefID-be6ef922-6316-4048-1111-ff6595fb9fa1': {
      flags: {
        [LD_FLAG_REFER_AND_EARN]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },

    /** tb-devloyalty */
    // root
    'baseXRefID-20347776-6159-4d42-a123-d20222ea7557': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
      },
    },
    // group
    'baseXRefID-dd02d640-bdee-47e2-9ba5-c5cc6df2b17d': {
      flags: {
        [LD_FLAG_GUEST_CRM]: true,
      },
    },
    'baseXRefID-b322b9d0-7f84-4071-a5c6-8c6051058b52': {
      flags: {
        [LD_FLAG_GUEST_CRM]: true,
      },
    },
    // venue
    'baseXRefID-42144': {
      flags: {
        [LD_FLAG_OO_DEV]: true,
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
      },
    },
    // venue
    'baseXRefID-42145': {
      flags: {},
    },
    /** tb-devloyalty */

    // tb-devmenu
    'baseXRefID-MOCKDONALDS': {
      flags: {
        [LD_FLAG_HIDE_PLU_RMM3]: false,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_ONTARIO': {
      flags: {
        [LD_FLAG_ENABLE_CASH_DISCOUNT]: true,
        [LD_FLAG_ADVANCED_DISCOUNT_V2]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_TORONTO': {
      flags: {
        [LD_FLAG_HIDE_PLU_RMM3]: false,
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_ENABLE_CASH_DISCOUNT]: true,
        [LD_FLAG_ADVANCED_DISCOUNT_V2]: true,
        [LD_FLAG_IOS_SHIFT_MANAGEMENT]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
        [LD_FLAG_STAFF_OVERTIME_RULES_2026]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_KINGSTON': {
      flags: {
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_WESTERN_CANADA': {
      flags: {
        [LD_FLAG_ADVANCED_DISCOUNT_V2]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_WINNIPEG': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        [LD_FLAG_ADVANCED_DISCOUNT_V2]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
        [LD_FLAG_IOS_SHIFT_MANAGEMENT]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_CALGARY': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_TB_LABOR]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_USA': {
      flags: {
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-MOCKDONALDS_NEW_YORK': {
      flags: {
        [LD_FLAG_HIDE_PLU_RMM3]: false,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_REFER_AND_EARN]: true,
      },
    },
    'baseXRefID-boat1': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_TB_LABOR]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
      },
    },
    'baseXRefID-boat2': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_TB_LABOR]: true,
        [LD_FLAG_REPORTING_V2_EXPERIMENT]: true,
      },
    },
    'baseXRefID-anonymous': {
      flags: {
        [LD_FLAG_RESET_RMM]: true,
      },
    },
    // tb-devreport
    'baseXRefID-24478': {
      flags: {
        [LD_FLAG_RESET_RMM]: true,
        [LD_FLAG_OO_DEV]: true,
        [LD_FLAG_DEVICE_LINKING]: true,
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_POS_ADMIN_POLICY_ASSIGNMENT]: true,
        [LD_FLAG_NEW_SELECTORS]: true,
      },
    },
    // tb-devmultiunit
    'baseXRefID-14628': {
      flags: {
        [LD_FLAG_RESET_RMM]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_V1]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_CASH_REGISTER_AUTO_NUMBERING]: true,
        [LD_FLAG_STATIC_CLOUD_FLOORPLAN_ENHANCEMENTS]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_TOUCH_CONTROL]: true,
        [LD_FLAG_PROMOTIONS]: true,
        [LD_FLAG_DEVICE_LINKING]: true,
        [LD_FLAG_SHOW_UPGRADE_USER_FLOW_2023_Q2]: true,
        [LD_FLAG_OO_DEV]: true,
        [LD_FLAG_POST_ACTIVATION_LANDING_PAGE]: true,
        [LD_SLF_CUSTOM_ROLES]: true,
      },
    },
    // Legacy venue with un-migrated floorplans hides floorplan options
    'baseXRefID-25556': {
      flags: {
        [LD_FLAG_SHOW_EMPTY_FLOORPLAN]: false,
        [LD_FLAG_CLOUD_FLOORPLAN_V1]: true,
      },
    },
    // Mock venue used with flags needed for menu navigation tests
    'baseXRefID-menuNavTestBaseXRefID1': {
      flags: {
        [LD_FLAG_PROMOTIONS]: true,
        [LD_FLAG_RESET_RMM]: true,
        [LD_FLAG_ALL_USER_ACCESS_IMPORT_EXPORT]: true,
        [LD_FLAG_DEVICE_LINKING]: true,
        [LD_FLAG_RMM3_STOCK_AVAILABILITY]: true,
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
      },
    },
    'baseXRefID-menuNavTestBaseXRefID2': {
      flags: {
        [LD_FLAG_UNPUBLISHED_CHANGES_INDICATOR]: true,
      },
    },
    'baseXRefID-048e3f50-51c9-4c2d-809a-0993e01d30da': {
      flags: {},
    },
    'baseXRefID-ec0bd2ff-3e53-4ddf-b03b-b326642b07e4': {
      flags: {},
    },
    'baseXRefID-groupNavTestBaseXRefID1': {
      flags: {},
    },
    'baseXRefID-groupNavTestBaseXRefID2': {
      flags: {},
    },
    'baseXRefID-b767b012-f53b-4eb4-8955-bc8e4234de4e': {
      flags: {
        [LD_FLAG_REFER_AND_EARN]: true,
        [LD_FLAG_CLOUD_FLOORPLAN_V1]: true,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
        [LD_FLAG_SALESFORCE_XP_CLOUD]: true,
      },
    },
    'baseXRefID-newSelectorFFTestingBase': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
      },
    },

    /** Payments TEAM */
    'baseXRefID-Cloud-9-CorporationXRefID': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS]: true,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
      },
    },
    'baseXRefID-Payrix': {
      flags: {
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },
    'baseXRefID-CHASE': {
      flags: {
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },
    // Payment Settings - Batch Close Feature Flag Test
    'baseXRefID-60000': {
      flags: {
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },
    'baseXRefID-60001': {
      flags: {
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },
    'baseXRefID-60002': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS]: true,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
        [LD_FLAG_MONERIS_TB_ONE_DEVICE_LINKING]: true,
      },
    },
    'baseXRefID-60003': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
      },
    },
    'baseXRefID-64200': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS]: true,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },
    'baseXRefID-60200': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS]: false,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_PAX]: true,
        [LD_FLAG_TB_ONE_DEVICE_LINKING]: true,
      },
    },
    'baseXRefID-63200': {
      flags: {
        [LD_FLAG_NEW_SELECTORS]: true,
        [LD_FLAG_ANDROID_QSR_CLOUD_PAYMENTS]: false,
        [LD_FLAG_PAYMENT_SETTINGS]: true,
        [LD_FLAG_RECEIPT_SETTINGS_IOS]: true,
      },
    },

    /** tb-devandroid */
    // root
    'baseXRefID-43e99108-3b36-4eb7-9455-6c28e4377e88': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_ANDROID_DISCOUNT_BLOCK]: true,
      },
    },
    // group
    'baseXRefID-82abc787-f7c0-4fde-8088-ceec5d1a6dcd': {
      flags: {
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_ANDROID_DISCOUNT_BLOCK]: true,
      },
    },
    // venue
    'baseXRefID-70002': {
      flags: {
        [LD_FLAG_OO_DEV]: true,
        [LD_SLF_CUSTOM_ROLES]: true,
        [LD_FLAG_ANDROID_DISCOUNT_BLOCK]: true,
      },
    },
    /** tb-devandroid */

    // Agent User for localdev, this resets on every VCS yarn db:prepare.
    // Tip: Log into localhost agent via Okta to enrol your user, then run:
    //  $ tb db venue-config-service
    //  tb_venueconfig_dev> select "userXRefID", username from users where username like '%tb-agent%'
    'userXRefID-5a3058d3-7a49-4c97-80b8-f708b4fec42d': {
      flags: {},
    },

    // Reservations
    ...reservationsFlags,

    // Reports
    ...reportsFlags,
  })
}

export const FeatureFlagClient = provider
